import { DataRole, DataType } from '@mode-switch/express';
export var Names;
(function (Names) {
    Names.Key = '$NAMES';
    Names.Name = 'Measure Names';
    function make() {
        const name = Names.Name;
        const source = "NAMES";
        const type = "DISCRETE";
        return {
            formula: formula(),
            name,
            source,
            type,
            role: "DIMENSION",
        };
    }
    Names.make = make;
    let Field;
    (function (Field) {
        function make(alias) {
            return { ...Names.make(), alias };
        }
        Field.make = make;
    })(Field = Names.Field || (Names.Field = {}));
    function formula() {
        const role = DataRole.Names.make();
        return { source: Names.Key, role, type: DataType.StringType.make() };
    }
})(Names || (Names = {}));
